import { baseApi, API_TAGS, createEndpointBuilder } from '@/shared/api';
import { Country } from '../model/types';

const countriesEndpoint = createEndpointBuilder('/api/v2/countries');

export const countriesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<Country[], void>({
      query: () => ({
        url: countriesEndpoint('')
      }),
      providesTags: [API_TAGS.COUNTRIES]
    })
  })
});

export const { useGetCountriesQuery } = countriesApi;
